<script>
import pagination from "@/mixins/pagination";
import taskDefaultList from "@/mixins/taskDefaultList";
import BaseSubNav from "@/components/ui/BaseSubNav.vue";

export default {
  name: "ReportsDefaultList",

  mixins: [pagination, taskDefaultList],

  components: {
    BaseSubNav,
  },

  data() {
    return {
      configType: "reports",
    };
  },
};
</script>

<template lang="pug">
  section
    BaseSubNav(
      navigationType="treatment"
      :showNavigation="true"
    )
      template(#title)
        | Reportes
        small(v-if="pagination.total")  ({{ pagination.total }})
      template(#actions)
        el-input.search__input(prefix-icon="el-icon-search" v-on:input="debounceInput" v-model="searchInput" placeholder="Buscar" :clearable="true")
        router-link.button.button--blue(:to="{name: 'create-task', params: { taskType: 'reports' }}" v-auth="'task-default.create'")
          micon(name="add_circle_outline").button__icon
          span.button__text Nuevo Reporte
    .box.box--with-subnav
      .box__content--stretch
        table
          thead
            tr
              th Nombre del Reporte
              th Acciones
          tbody
            spinner(v-if="isLoading && !tasks.length")
            tr(v-else, v-for="r in tasks", :key="r._id")
              td {{ r.name }}
              td.actions
                .actions-container
                  button.button.button--action(@click="edit(r._id)")
                    micon(name="edit")
                  button.button.button--action(@click="remove(r)")
                    micon(name="delete_forever")
      pagination(
        :isLoading="isLoading"
        :limit="pagination.limit",
        :total="pagination.total",
        @pagination="setPagination"
      )
</template>
